import React from 'react'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

export class GraphicYear extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      firstView: false,
      secondView: false,
      isMobile: window.innerWidth < 768
    }
  }

  render() {
    return (
      <div className='graphicyear'>
          <div className='wrapper'>
            <h2>Par année</h2>
            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  this.setState({ firstView: true })
                }
              }}
            />
            <img
              src={require('./image/year.jpg')}
              className={
                this.state.firstView ? 'ui fluid image active' : 'ui fluid image'
              }
            />
            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  this.setState({ secondView: true })
                }
              }}
            />
             <div className={
                this.state.secondView ? 'annotation active' : 'annotation'
              }>
             <div className='contain'>
                <div className='amount'>250 grammes</div>
                <img
                  src={require('./image/arrow.svg')}
                  className='arrow'
                />
              </div>
            </div>  
          </div>
      </div>
    )
  }
}

export default GraphicYear
